module.exports = __webpack_public_path__ + "img/M_ok.5a00552f.png";